<template>
  <div>
    <div v-if="isConfigRoute" class="row">
      <check-permission
        v-for="(group, index) in groups"
        :key="`group_${index}`"
        join-type="OR"
        :permissions="group.permissions"
      >
        <div class="col-md-4">
          <div class>
            <div class="card-header">
              {{ group.title }}
            </div>

            <ul class="list-group list-group-flush">
              <check-permission
                v-for="(link, linkIndex) in group.children"
                :key="`link_${linkIndex}`"
                :permissions="link.permissions"
              >
                <router-link class="link" :to="{ name: link.name }">
                  <li class="list-group-item">
                    <i v-if="link.icon" class="fal float-right" :class="link.icon" />

                    <strong>{{ link.title }}</strong>
                  </li>
                </router-link>
              </check-permission>
            </ul>
          </div>
        </div>
      </check-permission>
    </div>

    <router-view v-else />
  </div>
</template>

<script>
import CheckPermission from '@/components/helpers/CheckPermission';
import { generateConfig } from '@/utils/configuration';

export default {
  components: { CheckPermission },
  data() {
    return { groups: generateConfig() };
  },
  computed: {
    isConfigRoute() {
      return this.$route.name === 'config';
    }
  }
};
</script>

<style>
a.link {
  border-bottom: 1px solid #77c24b;
  border-top: none;
  color: #000;
}
.list-group {
  font-size: 0.94rem;
}
.list-group-item:hover,
a.link:focus .list-group-item {
  background-color: #f7f9fa;
}
.card-header {
  background-color: #77c24b;
  border-radius: 0 !important;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.9rem;
  color: black;
  padding: 0.6rem;
}
</style>
